import { Button } from 'atp-react-ui';

import { googleAnalytics4 } from '@/_services';

export function ContactSupportButton() {
  return (
    <Button
      as="link"
      size="sm"
      className="self-center"
      tag="a"
      target="_blank"
      href="https://help.achievetestprep.com/s/"
      onClick={() => {
        googleAnalytics4.event({
          category: 'Support',
          action: 'Contact Support',
        });
      }}
    >
      Contact Support
    </Button>
  );
}
